import { mapActions } from 'vuex'
import { ZONE_CLEAR, ZONE_DETAILS } from 'store/types'

export default
{
	props:
	{
		zoneId:
		{
			type:     [ Number, String ],
			required: true,
		},
	},

	watch:
	{
		zoneId:
		{
			immediate: true,

			handler(zoneId)
			{
				return this.loadZone({ zoneId })
			},
		},
	},

	methods:
	{
		...mapActions
		(
			{
				clearZone: ZONE_CLEAR,
				loadZone:  ZONE_DETAILS,
			}
		),
	},

	beforeDestroy()
	{
		this.clearZone()
	},
}